module.exports = __webpack_public_path__ + "img/logo.d18423c0.jpg";